<template>
  <div>
    <ModalView :active="active" @update:active="$emit('update:active', $event)">
      <template v-slot:body>
        <div class="d-flex flex-column g-4">
          <div v-if="parentOutput || selectedPath">
            <ButtonView v-if="parentOutput" type="normal" color="secondary" @click="selectOutput(parentOutput)">
              <div class="d-flex align-items-center g-2">
                <i class="fas fa-arrow-left"></i>
                <span>{{ parentOutput.title }}</span>
              </div>
            </ButtonView>
            <ButtonView v-else-if="selectedPath" type="normal" color="secondary" @click="selectOutput(undefined)">
              <div class="d-flex align-items-center g-2">
                <i class="fas fa-arrow-left"></i>
                <span>{{ translate('automation.trigger') }}</span>
              </div>
            </ButtonView>
          </div>
          <div v-if="currentOutput && (!comparable || currentOutput.type.comparable === true) && (!placeholderable || currentOutput.type.placeholderable === true) && selectedOutputs">
            <div class="card">
              <div class="card-body p-3">
                <h5 class="text-primary mb-0">{{ translate("selected") }}</h5>
                <div>
                  <span class="text-white" v-for="(output, index) in selectedOutputs.map(item => item.title)" :key="index">
                    <span>{{ output }}</span>
                    <i v-if="index < selectedOutputs.length - 1" class="fas fa-caret-right fa-sm mx-2"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentOptions && currentOptions.length > 0">
            <h4 v-if="currentOutput" class="mb-2">{{ currentOutput.title }}</h4>
            <div class="list-group">
              <div v-for="output in currentOptions" :key="output.key" class="list-group-item list-group-item-action" @click="selectOutput(output)">
                <div class="d-flex justify-content-between align-items-center">
                  <span>{{ output.title }}</span>
                  <span class="bg-secondary rounded-2 px-2 py-1 small">{{ output.type.title }} <i v-if="output.nullable" class="fas fa-question"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center g-4">
            <ButtonView type="normal" color="primary" class="w-100" @click="confirm" :disabled="!currentOutput || !(!comparable || currentOutput.type.comparable === true) || !(!placeholderable || currentOutput.type.placeholderable === true)">
              {{ translate("confirm") }}
            </ButtonView>
            <ButtonView type="normal" color="secondary" class="w-100" @click="$emit('update:active', false)">
              {{ translate("cancel") }}
            </ButtonView>
          </div>
        </div>
      </template>
    </ModalView>
  </div>
</template>

<script>
import {ModalView} from "@niftybit/vue";
import {ButtonView} from "@niftybit/vue";

export default {
  name: "OutputSelectionView",
  components: {ModalView, ButtonView},
  props: {
    value: String,
    trigger: Object,
    dataTypes: Array,
    comparable: Boolean,
    placeholderable: Boolean,
    active: Boolean
  },
  emits: ["update:value", "update:type", "update:active"],
  data() {
    return {
      selectedPath: this.value
    }
  },
  watch: {
    value() {
      if (this.selectedPath !== this.value) this.selectedPath = this.value;
    }
  },
  computed: {
    currentOutput() {
      return this.selectedPath && this.rootOutput ? this.getOutput(this.rootOutput, this.selectedPath.split(".")) : undefined;
    },
    currentOptions() {
      if (!this.selectedPath) return this.triggerOutputs;
      if (this.currentOutput) return this.currentOutput.type.outputs ? this.mapOutputs(this.currentOutput.type.outputs, this.currentOutput.path) : [];
      return this.mapOutputs(this.triggerOutputs, "");
    },
    parentOutput() {
      if (!this.selectedPath) return undefined;
      let split = this.selectedPath.split(".");
      if (split.length < 2) return undefined;
      return this.getOutput(this.rootOutput, split.slice(0, split.length - 1));
    },
    rootOutput() {
      if (!this.selectedPath) return undefined;
      let key = this.selectedPath.split(".")[0];
      return this.trigger.outputs.find(item => item.key === key);
    },
    triggerOutputs() {
      let list = this.trigger.outputs;
      list.forEach(item => {
        item.type = this.dataTypes.find(type => type.key === item.type.key);
        item.path = item.key;
      });
      return list;
    },
    selectedOutputs() {
      if (!this.currentOutput || !this.selectedPath) return undefined;
      let list = [];
      let split = this.selectedPath.split(".");
      for (let i = 1; i <= split.length; i++) {
        let output = this.getOutput(this.rootOutput, split.slice(0, i));
        output.path = split.slice(0, i).join(".");
        list.push(output);
      }
      return list;
    }
  },
  methods: {
    getOutput(current, path, pathBuilder) {
      pathBuilder = pathBuilder ?? [];
      pathBuilder.push(current.key);
      current.type = this.dataTypes.find(item => item.key === current.type.key);
      current.path = pathBuilder.join(".");
      if (path.length === 1) return current;
      let output = current.type.outputs.find(item => item.key === path[1]);
      return this.getOutput(output, path.slice(1, path.length), pathBuilder);
    },
    selectOutput(output) {
      this.selectedPath = output?.path;
    },
    mapOutputs(list, path) {
      return list.map(item => {
        item.type = this.dataTypes.find(type => type.key === item.type.key);
        item.path = path.length > 0 ? [...path.split("."), item.key].join(".") : item.key;
        return item;
      });
    },
    confirm() {
      this.$emit("update:active", false);
      this.$nextTick(() => {
        this.$emit("update:value", this.currentOutput?.path);
        this.$emit("update:type", this.currentOutput?.type);
        this.selectedPath = undefined;
      });
    }
  }
}
</script>

<style scoped>

</style>